import logo from "../../assets/IG_Logo_Circle.png";
import { Link } from "react-router-dom";

const PageHeader = () => {
  return (
    <div>
      <nav className="navbar navbar-expand-lg bg-body-tertiary container-fluid">
        <div className="container-fluid">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0 justify-content-center">
              <li className="nav-item">
                <button
                  className="nav-link active navbar-brand btn btn-link"
                  aria-current="page"
                >
                  <a
                    href="/"
                    className="navFont"
                    style={{
                      textDecoration: "none",
                      color: "black",
                      userSelect: "text",
                    }}
                  >
                    Home
                  </a>
                </button>
              </li>
              <li className="nav-item">
                <button className="nav-link navbar-brand btn btn-link">
                  <a
                    href="/services"
                    className="navFont"
                    style={{
                      textDecoration: "none",
                      color: "black",
                      userSelect: "text",
                    }}
                  >
                    Services
                  </a>
                </button>
              </li>
              <li className="nav-item">
                <button className="nav-link navbar-brand btn btn-link">
                  <Link
                    to="/about"
                    className="navFont"
                    style={{
                      textDecoration: "none",
                      color: "black",
                      userSelect: "text",
                    }}
                  >
                    About
                  </Link>
                </button>
              </li>
            </ul>
            <ul className="navbar-nav mb-2 mb-lg-0">
              <li className="nav-item">
                <button className="nav-link navbar-brand btn btn-link">
                  <a
                    href="tel:+18159321242"
                    className="navFont"
                    style={{
                      textDecoration: "none",
                      color: "black",
                      userSelect: "text",
                    }}
                  >
                    1-815-932-1242
                  </a>
                </button>
              </li>
              <li className="nav-item">
                <button className="nav-link navbar-brand btn btn-link">
                  <a
                    href="mailto:image-group@sbcglobal.net"
                    className="navFont"
                    style={{
                      textDecoration: "none",
                      color: "black",
                      userSelect: "text",
                    }}
                  >
                    image-group@sbcglobal.net
                  </a>
                </button>
              </li>
              <li className="nav-item">
                <button className="nav-link navbar-brand btn btn-link">
                  <a
                    href="https://www.google.com/maps?q=933+North+Convent+St,+Bourbonnais,+IL"
                    className="navFont"
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      textDecoration: "none",
                      color: "black",
                      userSelect: "text",
                    }}
                  >
                    933 N Convent St, Bourbonnais, IL 60914
                  </a>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <header className="headerStyle">
        <div style={{ display: "flex", alignItems: "center" }}>
          <div className="image-container" style={{ flex: "0 0 auto" }}>
            <img
              src={logo}
              className="App-logo"
              alt="logo"
              style={{ width: "200px", height: "200px" }}
            />
          </div>
          <div style={{ flex: "1", textAlign: "center" }}>
            <h1 className="headerFontAdjust headerFont">
              The Original Image Group
            </h1>
          </div>
        </div>
      </header>
    </div>
  );
};

export default PageHeader;
